<template>
  <div class="typhoon">
    <div class="top" v-loading="loading2" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="topdate">{{ date }}</div>
      <span class="title" v-if="istyphoon">“{{ tfname }}”台风</span>
      <span class="title" v-else>当前无台风</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping"></use>
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping"></use>
        </svg>
      </div>
      <div class="back" @click="back" v-show="backitem">
        <img src="@/assets/meiyu/back.png" alt="" />
        <span class="backdesc">返回</span>
      </div>
    </div>
    <div class="mapContent" :class="{ typhoonMap_active: typhoonBtnStatus }">
      <div v-loading="loading" id="centermap" class="homepage-map"></div>
      <div v-loading="loading" id="typhoonMap" class="homepage-map"></div>
    </div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col v-for="(item, index) in yj" :key="index" :span="4">
        <div class="grid-content bg-purple">
          <el-tooltip placement="bottom">
            <div slot="content" v-if="item.name === '预警村落'" class="warnItems">
              <div v-for="(item, index) in villageOver" :key="index" v-html="villageOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '水库超汛限'" class="warnItems">
              <div v-for="(item, index) in reservoirOver" :key="index" v-html="reservoirOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '河道水位超警'" class="warnItems">
              <div v-for="(item, index) in riverOver" :key="index" v-html="riverOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '雨量1h>30'" class="warnItems">
              <div v-for="(item, index) in rain1hOver" :key="index" v-html="rain1hOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '雨量3h>60'" class="warnItems">
              <div v-for="(item, index) in rain3hOver" :key="index" v-html="rain3hOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '雨量6h>80'" class="warnItems">
              <div v-for="(item, index) in rain6hOver" :key="index" v-html="rain6hOver[index]"></div>
            </div>
            <div>
              <p class="warn-name"><img v-if="item.iconUrl !== undefined" :src="item.iconUrl" width="18px" height="18px" style="margin-right:10px" />{{ item.name }}</p>
              <p class="warn-num">
                <b>{{ item.num }}</b
                ><span>个</span>
              </p>
            </div>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <div class="left">
      <div class="typhooninfo" v-loading="loading2" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="contain" v-if="istyphoon">
          <div>
            <span class="wordcolor"
              >{{ tfid }}
              <span>
                <el-select v-model="tfname" placeholder="请选择" popper-class="select-option" @change="currentSel">
                  <el-option v-for="item in tfarray" :key="item.value" :label="item.name" :value="item.tfid"> </el-option>
                </el-select> </span></span
            ><span class="distance">距永嘉：{{ distance }}km</span>
          </div>
          <div class="descrow">
            <span>等级：{{ tflevel }}</span
            ><span class="qiya"
              >气压：<span class="wordcolor">{{ tfqy }}百帕</span></span
            ><span class="fs"
              >风速：<span class="wordcolor">{{ tffs }}m/s</span></span
            >
          </div>
          <div class="descrow">
            <span
              >中心位置：<span class="wordcolor">东经{{ tflng }}° ，北纬{{ tflat }}°</span></span
            >
          </div>
        </div>
        <div class="contain" v-else>
          <img src="@/assets/meiyu/notyphoon.png" alt="" />
        </div>
      </div>
      <div class="realtimerain" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">实时雨情</span>
                <div class="selected_time">
                  <span class="time_item" :class="{ item_active: index == choosed }" v-for="(item, index) in selectedTime" :key="index" @click="checkItem(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
              <!-- <div class="button">前1小时</div> -->
            </div>
          </div>
          <div class="barcharts">
            <div class="qqmyl">
              <span class="allrain" @click="openAllrainDialog()">全县面雨量</span>
              <span class="val">{{ allrain }}<span class="danwei">mm</span></span>
            </div>
            <div id="rainchart"></div>
          </div>
        </div>
      </div>
      <div class="realtimewater" ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">单站</span>
                <div class="searchsta">
                  <el-input @change="datalist()" size="small" placeholder="请输入站名" v-model="staname" clearable>
                    <i @click="datalist()" slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content" ref="singleStationContent">
            <el-table
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              ref="singlesta"
              :data="statable"
              :height="tableheight"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName"
            >
              <el-table-column prop="name" label="站点名称" :min-width="minwidth">
                 <template  slot-scope="scope">
                  <div>
                    <span style="cursor:pointer"> {{ scope.row.name? scope.row.name : '- -' }}</span>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="addvnm" label="所属乡镇" min-width="45"> </el-table-column>
              <el-table-column align="center" prop="value" label="雨量" min-width="51" sortable> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="realtimewater rightrealtimewater" ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">实时水情</span>
                <div class="searchsta stawater">
                  <el-input @change="togglewater" size="small" placeholder="请输入站名" v-model="waterstaname" clearable>
                    <i @click="togglewater" slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <div class="selected_time" style="width: auto;position: absolute;right: 0;">
                  <span class="time_item" :class="{ item_active: index == choosed1 }" v-for="(item, index) in selectedReservoirRiver" :key="index" @click="checkItem1(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content" ref="realtimewaterContent">
            <!-- 河道 -->
            <!-- 超警 -->
            <el-table
              ref="overtabler"
              class="overtable"
              :data="overriverData"
              v-show="this.choosed1 === 1"
              stripe
              max-height="500"
              style="width:100%;"
              :row-class-name="tableRowClassName"
              @row-click="handleRowClick"
              @cell-mouse-enter="handleOverMouseEnter"
              @cell-mouse-leave="handleOverMouseOut"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="63">
                <template slot-scope="scope">
                  <div>
                    <span style="cursor:pointer"> {{ scope.row.stnm? scope.row.stnm : '- -' }}</span>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="45">
                <template slot-scope="scope">
                  {{ scope.row.water_Str ? scope.row.water_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超警戒" min-width="70" sortable :sort-method="sortMethod1">
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowGuaranteeWater_Str" label="超保证" min-width="70" sortable :sort-method="sortMethod2">
                <template slot-scope="scope">
                  {{ scope.row.overflowGuaranteeWater_Str ? scope.row.overflowGuaranteeWater_Str : '- -' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="historyHighestWater_Str"
                label="历史最高"
                min-width="63"
              >
                <template slot-scope="scope">
                  {{scope.row.historyHighestWater_Str ? scope.row.historyHighestWater_Str : '- -'}}
                </template>
              </el-table-column> -->
              <div slot="empty"></div>
            </el-table>
            <!-- 未超警 -->
            <el-table
              ref="commontable"
              :data="commonriverData"
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              v-show="this.choosed1 === 1"
              :height="commontableh"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName"
              :show-header="hiddenTableHeader"
              @row-click="handleRowClick"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="65">
                <template slot-scope="scope">
                 <div>
                    <span style="cursor:pointer"> {{ scope.row.stnm? scope.row.stnm : '- -' }}</span>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="45">
                <template slot-scope="scope">
                  {{ scope.row.water_Str ? scope.row.water_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超警戒" min-width="65" sortable :sort-method="sortMethod1">
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowGuaranteeWater_Str" label="超保证" min-width="70" sortable :sort-method="sortMethod2">
                <template slot-scope="scope">
                  {{ scope.row.overflowGuaranteeWater_Str ? scope.row.overflowGuaranteeWater_Str : '- -' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="historyHighestWater_Str"
                label="历史最高"
                min-width="63"
              >
                <template slot-scope="scope">
                  {{scope.row.historyHighestWater_Str ? scope.row.historyHighestWater_Str : '- -'}}
                </template>
              </el-table-column> -->
            </el-table>
            <!-- 水库 -->
            <!-- 超汛限 -->
            <el-table
              class="overrestable"
              :data="overresData"
              max-height="500"
              v-show="this.choosed1 === 0"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName1"
              @row-click="handleRowClick"
              @cell-mouse-enter="handleOverMouseEnter"
              @cell-mouse-leave="handleOverMouseOut"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="75">
                <template slot-scope="scope">
                  <div>
                    <span style="cursor:pointer"> {{ scope.row.stnm? scope.row.stnm : '- -' }}</span>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="45">
                <template slot-scope="scope">
                  {{ scope.row.water_Str ? scope.row.water_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="warningWater_Str" label="汛限水位" min-width="61">
                <template slot-scope="scope">
                  {{ scope.row.warningWater_Str ? scope.row.warningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超汛限" min-width="51" sortable>
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <div slot="empty"></div>
            </el-table>
            <!-- 未超汛 -->
            <el-table
              ref="commonrestable"
              :height="commonrestableh"
              :show-header="hiddenTableHeader"
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              :data="commonresData"
              v-show="this.choosed1 === 0"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName1"
              @row-click="handleRowClick"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="75">
                <template slot-scope="scope">
                  <div>
                    <span style="cursor:pointer"> {{ scope.row.stnm? scope.row.stnm : '- -' }}</span>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="45">
                <template slot-scope="scope">
                  {{ scope.row.water_Str ? scope.row.water_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="warningWater_Str" label="汛限水位" min-width="61">
                <template slot-scope="scope">
                  {{ scope.row.warningWater_Str ? scope.row.warningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超汛限" min-width="51" sortable>
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="tflj" :class="{ tflj_active: typhoonBtnStatus, tflj_disable: loading3 }" @click="typhoonpath"><img src="@/assets/meiyu/tflj.png" alt="" /></div>
    <el-dialog
      title="单站雨量统计"
      :visible.sync="dialogStation"
      :close-on-click-modal="false"
      id="danzhan"
      v-loading="dialogStationLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time">
              <span class="time_item" :class="{ item_active: index == choosed3 }" v-for="(item, index) in selectedTime" :key="index" @click="checkItem3(item, index)">
                <span>{{ item.name }}</span>
              </span>
            </div>
          </div>
          <img src="@/assets/meiyu/titlebottom.png" alt="" />
        </div>
      </div>
      <div class="topthree">
        <div class="topitem" v-for="(item, index) in alldz" :key="index">
          <img v-if="parseFloat(item.value) >= 50" src="@/assets/meiyu/redbox.png" alt="" />
          <img v-else src="@/assets/meiyu/bluebox.png" alt="" />
          <span class="topdesc">{{ item.name }}</span>
          <span class="val">{{ item.value }}<span class="danwei">mm</span></span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="全县面雨量"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      id="chartall"
      v-loading="dialogLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <!-- <span>{{thestation}}</span> -->
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time">
              <span class="time_item" :class="{ item_active: index == choosed2 }" v-for="(item, index) in selectedTime" :key="index" @click="checkItem2(item, index)">
                <span>{{ item.name }}</span>
              </span>
            </div>
          </div>
          <img src="@/assets/meiyu/titlebottom.png" alt="" />
        </div>
      </div>
      <div id="rainchartAll"></div>
    </el-dialog>
    <el-dialog title="台风期选择" :visible.sync="tfqdialogFormVisible" id="choset" :close-on-click-modal="false">
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time" style="margin-left:30px;">
              <el-date-picker v-model="tfqvalue1" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择台风期时间"> </el-date-picker>
            </div>
          </div>
        </div>
        <div style="width:100%;text-align:center;margin-top:30px;">
          <span slot="footer" class="dialog-footer">
            <el-button @click="tfqDialogCancel()">取 消</el-button>
            <el-button type="primary" @click="tyDefineTime">确 定</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import screenfull from 'screenfull'
import * as L from 'leaflet'
import monitorTypes from '@/store/types/monitor'
import meiyuTypes from '@/store/types/meiyu'
import typhoonMapTypes from '@/store/types/typhoonMap'
// import TyphoonMap from './typhoonMap'
// import homepageTypes from '@/store/types/homepage'
// import config from '@/config'
import request from '@/utils/request'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
let typhoonImg = require('../../assets/map/images/typhoon.gif')
var echarts = require('echarts')
export default {
  components: {},
  data() {
    return {
      enterList: true,
      commontableh: '50',
      commonrestableh: '50',
      hiddenTableHeader: false,
      staname: '',
      waterstaname: '',
      backitem: true,
      zzloading: true,
      loading1: false,
      loading2: true,
      loading3: true,
      tfqvalue1: '',
      tfqdialogFormVisible: false,
      tfarray: [],
      watchfull: '',
      isFullscreen: false,
      myChartHeight: '',
      dialogFormVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      allrain: '',
      watername: '',
      wateroverflow: '',
      aDDVCD: '330324',
      documentwidth: document.documentElement.clientWidth,
      loading: true,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      mapheight: document.body.scrollHeight + 'px',
      tableheight: 10,
      rtableheight: 10,
      superpolice: [],
      gates: [],
      tableData: [],
      overriverData: [],
      commonriverData: [],
      overresData: [],
      commonresData: [],
      selectedTime: [
        {
          name: '台风期',
          value: ''
        },
        {
          name: '当日',
          value: '24h'
        },
        {
          name: '前3小时',
          value: '3h'
        },
        {
          name: '前1小时',
          value: '1h'
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        },
        {
          name: '河道',
          value: 'river'
        }
      ],
      choosed: 3,
      choosed2: 3,
      choosed3: 3,
      chooseItem: '',
      isChartShow: false,
      dialogVisible: false,
      dialogLoading: false,
      dialogStation: false,
      dialogStationLoading: false,
      alldz: [],
      choosed1: 1,
      gataData: [],
      minwidth: '75',
      moregate: [],
      yj: [
        { name: '预警村落', num: 0, iconUrl: require('@/assets/meiyu/yjcl.png') },
        { name: '水库超汛限', num: 0, iconUrl: require('@/assets/meiyu/skcxx.png') },
        { name: '河道水位超警', num: 0, iconUrl: require('@/assets/meiyu/swcj.png') },
        { name: '雨量1h>30', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') },
        { name: '雨量3h>60', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') },
        { name: '雨量6h>80', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') }
      ],
      villageOver: [],
      reservoirOver: [],
      riverOver: [],
      rain1hOver: [],
      rain3hOver: [],
      rain6hOver: [],
      villageOverMarker: [],
      reservoirOverMarker: [],
      riverOverMarker: [],
      rain1hOverMarker: [],
      rain3hOverMarker: [],
      rain6hOverMarker: [],
      sID: '22',
      sTID: '214',
      stationType: '2',
      waterFactor: '',
      rivercoordinate: [],
      map: '',
      tfid: '',
      tfname: '',
      tflevel: '',
      tfqy: '',
      tffs: '',
      tflat: '',
      tflng: '',
      distance: '',
      istyphoon: false,
      typhoonBtnStatus: false,
      typhoonTestData: [],
      typhoonActivity: [],
      allpoints: '',
      count: 0,
      typhoonIcon: '',
      land: '',
      lineLayer: '',
      marker: '',
      polyline: '',
      typhoonMap: {},
      tabName: '河道',
      statable: [],
      minGuarantee: 0,
      minWarning: 0,
      isShowToolip: false,
      hoverCurrentStcd: ''
    }
  },
  methods: {
    // 未超警
    handleMouseEnter(row, column, cell, event) {
      this.enterList = false
      this.hoverCurrentStcd = row.stcd // 显示当前stcd站点
    },
    handleMouseOut(row, column, cell, event) {
      this.enterList = true
      this.hoverCurrentStcd = ''
    },
    // 超警
    handleOverMouseEnter(row, column, cell, event) {
      this.hoverCurrentStcd = row.stcd // 显示当前stcd站点
    },
    handleOverMouseOut(row, column, cell, event) {
      this.hoverCurrentStcd = ''
    },
    // 河道/水库水情行选中定位坐标
    handleRowClick(item) {
      // selectMapLayer1(this, item, this.map)
    },
    // 单站数据
    datalist () {
      this.$store.dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
        beginTime: this.tfqvalue1,
        stationName: this.staname
      }).then(data => {
        this.statable = data.stationRain
      })
    },
    togglewater() {
      if (this.choosed1 === 1) {
        this.riverwater()
      } else {
        this.reservoirwater()
      }
    },
    // 列排序
    sortChange1(a, b) {
      return Number(a.overflowWarningWater_Str) - Number(b.overflowWarningWater_Str)
    },
    sortChange2(a, b) {
      return Number(a.overflowGuaranteeWater_Str) - Number(b.overflowGuaranteeWater_Str)
    },
    sortMethod1(a, b) {
      let bsort = b.overflowWarningWater_Str === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater_Str)
      let asort = a.overflowWarningWater_Str === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater_Str)
      return bsort - asort
    },
    sortMethod2(a, b) {
      let bsort = b.overflowGuaranteeWater_Str === undefined ? this.minGuarantee - 1 : Number(b.overflowGuaranteeWater_Str)
      let asort = a.overflowGuaranteeWater_Str === undefined ? this.mminGuarantee - 1 : Number(a.overflowGuaranteeWater_Str)
      return bsort - asort
    },
    currentSel(id) {
      this.loading2 = true
      this.tfid = id
      this.gettyphooninfo()
    },
    typhoonpath() {
      this.typhoonBtnStatus = !this.typhoonBtnStatus
    },
    buttonfull() {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    back() {
      this.$router.go(-1)
    },
    drawChart(chartname, topsixvalue) {
      let maxRain = Math.max(...topsixvalue) // 乡镇面雨量最大值
      if (maxRain > 10) {
        maxRain = maxRain + 5
      } else {
        maxRain = 10
      }
      let myChart = this.$echarts.init(document.getElementById('rainchart'))
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          text: '乡镇面雨量Top3',
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '-4%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartname,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function() {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            max: Math.ceil(maxRain) // 最大值
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalue,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    drawChartAll(chartnameAll, topsixvalueAll) {
      let maxRain = Math.max(...topsixvalueAll) // 全县面雨量最大值
      if (maxRain > 10) {
        maxRain = maxRain + 5
      } else {
        maxRain = 10
      }
      let myChart = this.$echarts.init(document.getElementById('rainchartAll'))
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartnameAll,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function() {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            max: Math.ceil(maxRain) // 最大值
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalueAll,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    tableRowClassName({ row, rowIndex }) {
      let over = row.overflowGuaranteeWater_Str
      if (over === undefined) {
        over = -9999
      } else {
        over = parseFloat(over)
      }
      if (row.overflowWarningWater > 0 && over <= 0) {
        // 超警戒未超保证
        return 'warning-row'
      } else if (over > 0) {
        return 'success-row'
      }
      return ''
    },
    tableRowClassName1({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        // 超汛限
        return 'success-row'
      }
      return ''
    },
    getnowtime() {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date = year + '年' + this.conver(month) + '月' + this.conver(date) + '日' + ' ' + weekend + ' ' + this.conver(hours) + ':' + this.conver(minutes) + ':' + this.conver(seconds)
    },
    conver(s) {
      return s < 10 ? '0' + s : s
    },
    typhoonmap() {
      var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        maxZoom: 18,
        minZoom: 5
      })
      var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        maxZoom: 18,
        minZoom: 5
      })
      var image = L.layerGroup([imgm, imga])
      let map = ''
      if (this.documentwidth <= 1400) {
        map = L.map('centermap', {
          center: [28.355, 120.629],
          zoom: 10,
          layers: [image],
          zoomControl: false
        })
      } else {
        map = L.map('centermap', {
          center: [28.355, 120.629],
          zoom: 11,
          layers: [image],
          zoomControl: false
        })
      }
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      request.get(window.location.origin + '/yjjson/yongjiaTown.json').then((res) => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
        this.drawBoundary(res.data.features[0].geometry.coordinates, map)
      })
    },
    leaflet(arr) {
      let map = ''
      map = L.CreateTianDiTuMap('centermap', {
        mapType: 3,
        minZoom: 10, // 最小缩放等级
        maxZoom: 18,
        crs: L.CRS.EPSG4490,
        zoomControl: false
      }).setView([28.33, 120.68], 11)
      // L.tileLayer.CustomArcGISServerLayer(
      //   config.ApiYJ + '/assets/images/town/' // 地图服务地址
      // ).addTo(map)
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then((res) => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
        // this.drawBoundary(res.data.features[0].geometry.coordinates[0], map)
      })
      this.map = map
      this.map.on('zoomend', e => {
        this.zoomFn(e)
      })
    },
    zoomFn (e) {
      let arr = []
      this.Global.filterArr(arr, this.villageOverMarker, this.reservoirOverMarker, this.riverOverMarker, this.rain1hOverMarker, this.rain3hOverMarker)
      if (e.target._zoom > 11) {
        arr.forEach(el => {
          el.unbindTooltip()
          el.bindTooltip(el.options.tooltipShow, { permanent: true, sticky: true })
        })
      } else {
        for (const key in this.map._layers) {
          let el = this.map._layers[key]
          if (el.options.tooltipShow) {
            el.unbindTooltip()
            el.bindTooltip(el.options.tooltipShow, { permanent: false, sticky: true })
          }
        }
      }
    },
    layerDeal (layer) { // 提取图层中的锚点  L.layerGroup(layers)时调用
      let arr = []
      if (layer) {
        for (const key in layer._layers) {
          arr.push(layer._layers[key])
        }
      }
      return arr
    },
    drawBoundary(blist, map) {
      // 画遮蔽层的相关方法
      // 思路: 首先在中国地图最外画一圈，圈住理论上所有的中国领土，然后再将每个闭合区域合并进来，并全部连到西北角。
      // 这样就做出了一个经过多次西北角的闭合多边形
      // 定义中国东南西北端点，作为第一层
      var pNW = { lat: 59.0, lng: 73.0 }
      var pNE = { lat: 59.0, lng: 136.0 }
      var pSE = { lat: 3.0, lng: 136.0 }
      var pSW = { lat: 3.0, lng: 73.0 }
      // 向数组中添加一次闭合多边形，并将西北角再加一次作为之后画闭合区域的起点
      var pArray = []
      pArray.push(pNW)
      pArray.push(pSW)
      pArray.push(pSE)
      pArray.push(pNE)
      pArray.push(pNW)
      // 循环添加各闭合区域
      for (var i = 0; i < blist.length; i++) {
        var points = []
        blist[i].forEach((item) => {
          points.push({ lat: item[1], lng: item[0] })
        })
        // $.each(blist[i],function(k,v){
        //     points.push({lat:v[1],lng:v[0]})
        // })
        // 将闭合区域加到遮蔽层上，每次添加完后要再加一次西北角作为下次添加的起点和最后一次的终点
        pArray = pArray.concat(points)
        pArray.push(pArray[0])
      }
      // 添加遮蔽层
      var plyall = L.polygon(pArray, { color: 'transparent', fillColor: '#242422', fillOpacity: 0.8 }) // 建立多边形覆盖物
      plyall.addTo(map)
    },
    tyDefineTime() {
      this.tfqdialogFormVisible = false
      this.isChartShow = true
      this.tfchange(true, true, this.selectedTime[this.choosed])
    },
    // 实时雨情点击切换
    checkItem(item, index) {
      this.choosed = index
      this.chooseItem = item
      if (index === 0) {
        this.tfqdialogFormVisible = true
        let myChart = this.$echarts.init(document.getElementById('rainchart'))
        myChart.clear()
        this.allrain = ''
        this.tops = []
        this.alldz = []
        this.isChartShow = false
      } else {
        this.tfqdialogFormVisible = false
        this.tfchange(true, true, item)
      }
    },
    // 实时雨情-全县面雨量点击切换
    checkItem2(item, index) {
      this.choosed2 = index
      if (index === 0) {
        if (this.isChartShow) {
          this.dialogLoading = true
          this.tfchange(false, true, item)
        } else {
          let myChart = this.$echarts.init(document.getElementById('rainchartAll'))
          myChart.clear()
        }
      } else {
        this.dialogLoading = true
        this.tfchange(false, true, item)
      }
    },
    checkItem3(item, index) {
      this.choosed3 = index
      if (index === 0) {
        if (this.isChartShow) {
          this.dialogStationLoading = true
          this.tfchange(false, false, item)
        } else {
          this.alldz = []
        }
      } else {
        this.dialogStationLoading = true
        this.tfchange(false, false, item)
      }
    },
    openAllrainDialog() {
      this.dialogVisible = true
      this.checkItem2(this.chooseItem, this.choosed)
    },
    // 台风日期选择
    tfchange(isOut, isChart, item) {
      if (isOut) {
        this.loading1 = true
      }
      this.$store
        .dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
          beginTime: this.tfqvalue1,
          stationName: this.staname,
          type: item.value
        })
        .then((data) => {
          if (isOut) {
            this.allrain = data.avgRain
            let chartData = data.townRain
            // top3测站排序
            const handleSort = (prop) => {
              return function(a, b) {
                const val1 = a[prop]
                const val2 = b[prop]
                return val2 - val1
              }
            }
            chartData = chartData.sort(handleSort('value')) // 排序后top3
            let chartname = []
            let topsixvalue = []
            chartData.slice(0, 3).forEach((item) => {
              chartname.push(item.name)
              topsixvalue.push(item.value)
            })
            this.drawChart(chartname, topsixvalue)
            let sortlist = data.stationRain
            this.statable = sortlist.sort((a, b) => {
              let bsort = b.value === null ? -1 : b.value
              let asort = a.value === null ? -1 : a.value
              return bsort - asort
            })
            this.loading1 = false
          } else {
            if (isChart) {
              let chartData = data.townRain
              // let chartname = []
              // let topsixvalue = []
              // chartData.forEach((item) => {
              //   chartname.push(item.name)
              //   topsixvalue.push(item.value)
              // })
              // 全县面雨量测站排序
              const handleSort = (prop) => {
                return function(a, b) {
                  const val1 = a[prop]
                  const val2 = b[prop]
                  return val2 - val1
                }
              }
              chartData = chartData.sort(handleSort('value')) // 排序后全县面雨量
              let chartname = []
              let topsixvalue = []
              chartData.forEach((item) => {
                let reg1 = new RegExp('镇', 'g')// g代表全部
                let reg2 = new RegExp('乡', 'g')// g代表全部
                let reg3 = new RegExp('县', 'g')// g代表全部
                let reg4 = new RegExp('街道', 'g')// g代表全部
                item.name = item.name.replace(reg1, '').replace(reg2, '').replace(reg3, '').replace(reg4, '')
                chartname.push(item.name)
                topsixvalue.push(item.value)
              })
              this.drawChartAll(chartname, topsixvalue)
              this.dialogLoading = false
            } else {
              this.alldz = data.stationRain
              this.dialogStationLoading = false
            }
          }
        })
    },
    // 实时水情点击切换
    checkItem1(item, index) {
      this.choosed1 = index
      let _this = this
      this.$nextTick(() => {
        let contentDiv = document.getElementsByClassName('right')
        let overresDiv = document.getElementsByClassName('overrestable')
        if (window.screen.width <= 1366) {
          _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 105 + 'px'
        } else {
          _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 15 + 'px'
        }
      })
      // if (this.choosed1 === 0) {
      //   this.reservoirwater()
      // } else {
      //   this.riverwater()
      // }
    },
    // 河道水情
    async riverwater() {
      this.minwidth = '87'
      this.tabName = '河道'
      this.watername = '超保证'
      this.wateroverflow = 'overflowWarningWater'
      await this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
          aDDVCD: this.aDDVCD,
          stationName: this.waterstaname,
          orderField: this.wateroverflow,
          desc: true
        })
        .then((data) => {
          // this.tableData = data.rows
          let arr = data.rows
          if (arr) {
            this.overriverData = []
            this.commonriverData = []
            arr.forEach((el) => {
              if (el.overflowWarningWater > 0) {
                this.overriverData.push(el)
              } else {
                this.commonriverData.push(el)
              }
            })
          }
          // 河道水位超警戒排序,获取最小值
          let filterWaterData = this.tableData.filter((item) => {
            // 过滤数组中undefined类型
            return item.overflowWarningWater !== undefined
          })
          let min = Math.min.apply(
            Math,
            filterWaterData.map((item) => {
              return item.overflowWarningWater
            })
          )
          this.minWarning = min
          // 河道水位超保证排序,获取最小值
          let filterGuaranteeWaterData = this.tableData.filter((item) => {
            // 过滤数组中undefined类型
            return item.overflowGuaranteeWater !== undefined
          })
          let min1 = Math.min.apply(
            Math,
            filterGuaranteeWaterData.map((item) => {
              return item.overflowGuaranteeWater
            })
          )
          this.minGuarantee = min1
          this.loading = false
        })
    },
    // 水库水情
    async reservoirwater() {
      this.minwidth = '75'
      this.tabName = '水库'
      this.watername = '超汛限'
      this.wateroverflow = 'overflowWarningWater'
      await this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
          aDDVCD: this.aDDVCD,
          stationName: this.waterstaname,
          orderField: this.wateroverflow,
          desc: true
        })
        .then((data) => {
          let temp = data.rows
          let arr = temp
          if (arr) {
            this.overresData = []
            this.commonresData = []
            arr.forEach((el) => {
              if (el.overflowWarningWater > 0) {
                this.overresData.push(el)
              } else {
                this.commonresData.push(el)
              }
            })
          }

          temp.sort((a, b) => {
            let bsort = b.overflowWarningWater_Str === undefined ? -89999 : b.overflowWarningWater_Str
            let asort = a.overflowWarningWater_Str === undefined ? -89999 : a.overflowWarningWater_Str
            return bsort - asort
          })
          this.tableData = temp
          this.loading = false
        })
    },
    // 获取台风信息
    gettyphooninfo() {
      let _this = this
      this.$store.dispatch(typhoonMapTypes.GET_TYPHOON_ACTIVITY, { tfid: this.tfid }).then((data) => {
        if (this.tfid === '') {
          this.tfarray = data
        }
        if (data.length !== 0) {
          _this.istyphoon = true
          let tfinfo = data[0]
          data.forEach((d) => {
            if (d.tfid === this.tfid) {
              tfinfo = d
            }
          })
          _this.tfname = tfinfo.name
          _this.tflevel = tfinfo.strong
          _this.tfqy = tfinfo.pressure
          _this.tffs = tfinfo.speed
          _this.tfid = tfinfo.tfid
          _this.tflat = tfinfo.lat
          _this.tflng = tfinfo.lng
          _this.distance = this.GetDistance(this.tflat, this.tflng, 30.23, 119.72).toFixed(2)
          _this.loading2 = false
          _this.tfarray.forEach((item) => {
            _this.tfid = item.tfid
            _this.loading = false
            _this.getTyphoonInfo1(item)
          })
        } else {
          _this.istyphoon = false
          _this.loading2 = false
          _this.drawTyphoonRouter()
        }
      })
    },
    // 计算两坐标点的距离
    GetDistance(lat1, lng1, lat2, lng2) {
      var radLat1 = (lat1 * Math.PI) / 180.0
      var radLat2 = (lat2 * Math.PI) / 180.0
      var a = radLat1 - radLat2
      var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
      s = s * 6378.137 // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000
      return s
    },
    rainoverflow() {
      this.$store.dispatch(meiyuTypes.GET_WATER_OVERFLOW, { sID: '22' }).then((data) => {
        this.yj[3].num = data.total1
        this.yj[4].num = data.total3
        this.yj[5].num = data.total6
        data.rowsOf1h.forEach((item) => {
          this.rain1hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 1小时雨量:<span class='red'>${item.rain1}</span>mm`)
        })
        if (this.rain1hOver.length === 0) {
          this.rain1hOver.push('暂无超警')
        }
        data.rowsOf3h.forEach((item) => {
          this.rain3hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 3小时雨量:<span class='red'>${item.rain3}</span>mm`)
        })
        if (this.rain3hOver.length === 0) {
          this.rain3hOver.push('暂无超警')
        }
        data.rowsOf6h.forEach((item) => {
          this.rain6hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 6小时雨量:<span class='red'>${item.rain6}</span>mm`)
        })
        if (this.rain6hOver.length === 0) {
          this.rain6hOver.push('暂无超警')
        }
        if (data.total1 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf1h
          coordinates.forEach((item) => {
            let html = '<b>' + item.stnm + '</b>'
            let markersname = item.stid || item.id || item.adcd || item.stcd
            let markers = L.marker([item.lttd, item.lgtd], {
              icon: reservior,
              data: item,
              tooltipShow: html,
              name: markersname // 唯一标识
            }).addTo(this.map)
            markers.bindTooltip(html, {
              parmanent: this.map._zoom > 11,
              sticky: true,
              className: 'anim-tooltip'
            })
            this.rain1hOverMarker.push(markers)
          })
        }
        if (data.total3 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf3h
          coordinates.forEach((item) => {
            let html = '<b>' + item.stnm + '</b>'
            let markersname = item.stid || item.id || item.adcd || item.stcd
            let markers = L.marker([item.lttd, item.lgtd], {
              icon: reservior,
              data: item,
              tooltipShow: html,
              name: markersname // 唯一标识
            }).addTo(this.map)
            markers.bindTooltip(html, {
              parmanent: this.map._zoom > 11,
              sticky: true,
              className: 'anim-tooltip'
            })
            this.rain3hOverMarker.push(markers)
          })
        }
        if (data.total6 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf6h
          coordinates.forEach((item) => {
            let html = '<b>' + item.stnm + '</b>'
            let markersname = item.stid || item.id || item.adcd || item.stcd
            let markers = L.marker([item.lttd, item.lgtd], {
              icon: reservior,
              data: item,
              tooltipShow: html,
              name: markersname // 唯一标识
            }).addTo(this.map)
            markers.bindTooltip(html, {
              parmanent: this.map._zoom > 11,
              sticky: true,
              className: 'anim-tooltip'
            })
            this.rain6hOverMarker.push(markers)
          })
        }
      })
    },
    resoverflow(type) {
      this.$store.dispatch(meiyuTypes.GET_RES_OVERFLOW, { stationType: type, sID: '22' }).then((data) => {
        if (type === 1) {
          this.yj[2].num = data.riverWarningTotal
          data.rows.forEach((item) => {
            this.riverOver.push(`<span>${item.stnm}</span>水位:${item.water}m 警戒水位:${item.wrz}m 超警戒水位:<span class='red'>${this.global.formatNumber(item.water - item.wrz, 2)}</span>m`)
          })
          if (this.riverOver.length === 0) {
            this.riverOver.push('暂无超警')
          }
          if (data.riverWarningTotal > 0) {
            var river = L.icon({
              iconUrl: require('@/assets/meiyu/swcj.png'),
              shadowUrl: require('@/assets/meiyu/swcj.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rows
            coordinates.forEach((item) => {
              let html = '<b>' + item.stnm + '  水位' + (item.water || item.water === 0 ? item.water : '-') + 'm' + '</b>'
              let markersname = item.stid || item.id || item.adcd || item.stcd
              var markers = L.marker([item.lttd, item.lgtd], {
                icon: river,
                data: item,
                tooltipShow: html,
                name: markersname // 唯一标识
              }).addTo(this.map)
              markers.bindTooltip(html, {
                parmanent: this.map._zoom > 11,
                sticky: true,
                className: 'anim-tooltip'
              })
              this.riverOverMarker.push(markers)
            })
          }
        } else {
          this.yj[1].num = data.reservoirTotal
          data.rows.forEach((item) => {
            this.reservoirOver.push(`<span>${item.stnm}</span>水位:${item.water}m 汛限水位:${item.wrz}m 超汛限水位:<span class='red'>${this.global.formatNumber(item.water - item.wrz, 2)}</span>m`)
          })
          if (this.reservoirOver.length === 0) {
            this.reservoirOver.push('暂无超警')
          }
          if (data.reservoirTotal > 0) {
            var reservior = L.icon({
              iconUrl: require('@/assets/meiyu/skcxx.png'),
              shadowUrl: require('@/assets/meiyu/skcxx.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rows
            coordinates.forEach((item) => {
              let html = '<b>' + item.stnm + '  水位' + (item.water || item.water === 0 ? item.water : '-') + 'm' + '</b>'
              let markersname = item.stid || item.id || item.stcd || item.adcd
              var markers = L.marker([item.lttd, item.lgtd], {
                icon: reservior,
                data: item,
                tooltipShow: html,
                name: markersname // 唯一标识
              }).addTo(this.map)
              markers.bindTooltip(html, {
                parmanent: this.map._zoom > 11,
                sticky: true,
                className: 'anim-tooltip'
              })
              this.reservoirOverMarker.push(markers)
            })
          }
        }
      })
    },
    warnvillage() {
      this.$store.dispatch(meiyuTypes.GET_WARN_VILLAGE, { pageIndex: '1', pageSize: '100' }).then((data) => {
        this.yj[0].num = data.total
        data.results.forEach((item, index) => {
          this.villageOver.push(item.stnm)
        })
        if (this.villageOver.length === 0) {
          this.villageOver.push('暂无超警')
        }
        if (data.total > 0) {
          var reservior = L.icon({
            iconUrl: require('@/assets/meiyu/yjcl.png'),
            shadowUrl: require('@/assets/meiyu/yjcl.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.results
          coordinates.forEach((item) => {
            let markers = L.marker([item.lat, item.lng], { icon: reservior }).addTo(this.map)
            markers.bindTooltip('<b>' + item.adnm + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
          })
        }
      })
    },
    getTyphoonInfo1(tfinfo) {
      this.$store
        .dispatch(typhoonMapTypes.GET_TYPHOON_INFO, {
          tfid: this.tfid
        })
        .then((data) => {
          this.typhoonTestData = data
          this.tfqvalue1 = this.typhoonTestData.starttime
          this.drawTyphoonRouter(tfinfo, this.typhoonTestData)
          this.coumputedForecastRoute(this.typhoonTestData) // 绘制预测路线
          this.loading = false
        })
    },
    // 处理预测路线数据
    coumputedForecastRoute(typhoonInfo) {
      let _this = this
      let allLinePointArr = [
        {
          area: '中国',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '中国香港',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '中国台湾',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '美国',
          pointArr: [],
          linePointArr: []
        },
        {
          area: '日本',
          pointArr: [],
          linePointArr: []
        }
      ]
      let lastPoint = typhoonInfo.points.length - 1
      typhoonInfo.points[lastPoint].forecast.forEach((item, index) => {
        // console.log(item, index, 'eli')
        let area = item.tm
        item.forecastpoints.forEach((el, i) => {
          let tempLatLngArr = []
          let tempLat = []
          let tempLng = []
          tempLat = el.lat
          tempLng = el.lng
          tempLatLngArr.push(tempLat, tempLng)
          switch (area) {
            case '中国':
              allLinePointArr[0].linePointArr.push(tempLatLngArr)
              allLinePointArr[0].pointArr.push(el)
              break
            case '中国香港':
              allLinePointArr[1].linePointArr.push(tempLatLngArr)
              allLinePointArr[1].pointArr.push(el)
              break
            case '中国台湾':
              allLinePointArr[2].linePointArr.push(tempLatLngArr)
              allLinePointArr[2].pointArr.push(el)
              break
            case '美国':
              allLinePointArr[3].linePointArr.push(tempLatLngArr)
              allLinePointArr[3].pointArr.push(el)
              break
            case '日本':
              allLinePointArr[4].linePointArr.push(tempLatLngArr)
              allLinePointArr[4].pointArr.push(el)
              break
            default:
              break
          }
        })
      })
      // console.log(allLinePointArr, 'drawForecastRoute')
      allLinePointArr.forEach((item) => {
        _this.drawForecastLine(item.linePointArr, item.area)
        _this.drawForecastPoint(item.pointArr, item.area)
      })
    },
    // 绘制预测点
    drawForecastPoint(pointData, area) {
      let map = this.typhoonMap
      pointData.forEach((item, index) => {
        let myIcon1 = L.icon({
          iconUrl: require('@/assets/map/images/marker1.png'),
          iconSize: [15, 15]
        })
        let myIcon2 = L.icon({
          iconUrl: require('@/assets/map/images/marker2.png'),
          iconSize: [15, 15]
        })
        let myIcon3 = L.icon({
          iconUrl: require('@/assets/map/images/marker3.png'),
          iconSize: [15, 15]
        })
        let myIcon4 = L.icon({
          iconUrl: require('@/assets/map/images/marker4.png'),
          iconSize: [15, 15]
        })
        let myIcon5 = L.icon({
          iconUrl: require('@/assets/map/images/marker5.png'),
          iconSize: [15, 15]
        })
        let myIcon6 = L.icon({
          iconUrl: require('@/assets/map/images/marker6.png'),
          iconSize: [15, 15]
        })
        let myIcon = myIcon1
        let points = [Number(item['lat']), Number(item['lng'])]
        let powerValue = item.power
        if (powerValue > 5 && powerValue <= 7) {
          // 热带低压6-7
          myIcon = myIcon1
        } else if (powerValue > 7 && powerValue <= 9) {
          // 热带风暴8-9
          myIcon = myIcon2
        } else if (powerValue > 9 && powerValue <= 11) {
          // 强热带风暴10-11
          myIcon = myIcon3
        } else if (powerValue > 11 && powerValue <= 13) {
          // 台风12-13
          myIcon = myIcon4
        } else if (powerValue > 13 && powerValue <= 15) {
          // 强台风14-15
          myIcon = myIcon5
        } else if (powerValue >= 16) {
          // 超强台风>=16
          myIcon = myIcon6
        }
        let markers = L.marker(points, { icon: myIcon }).bindTooltip(
          '<div class="typhoonName"><h3>' +
            area +
            '</h3>' +
            '<span class="time">' +
            item.time +
            ' 预报' +
            '</span>' +
            '</div>' +
            '<div id="tab">' +
            '<ul class="tab">' +
            '<li class="tab_nav on">' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>当前位置:</span></div>' +
            '<div class="contentnum"><span>' +
            item.lng +
            '°' +
            '/' +
            item.lat +
            '°' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>中心气压:</span></div>' +
            '<div class="contentnum"><span>' +
            item.pressure +
            ' 百帕' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>最大风速:</span></div>' +
            '<div class="contentnum"><span>' +
            item.speed +
            ' 米/秒' +
            '</span></div>' +
            '</div>' +
            '<div class="tabcontnet">' +
            '<div class="contentname"><span>风力:</span></div>' +
            '<div class="contentnum"><span>' +
            item.power +
            '级' +
            '</span></div>' +
            '</div>' +
            '</li>' +
            '</ul>' +
            '</div>',
          {
            parmanent: true,
            direction: 'top',
            sticky: true,
            className: 'animate-tooltip'
          }
        )
        markers.addTo(map)
      })
    },
    // 绘制预测虚线
    // L.polyline(linestr24, { color: '#BFBF04', weight: 2, dashArray: '5' }).addTo(map) // 虚线
    drawForecastLine(lineData, area) {
      let map = this.typhoonMap
      let color = '#000000'
      switch (area) {
        case '中国':
          color = '#FF3C4E'
          break
        case '中国香港':
          color = '#FEBD00'
          break
        case '中国台湾':
          color = '#FF00FE'
          break
        case '美国':
          color = '#04FAF7'
          break
        case '日本':
          color = '#24BC00'
          break
        default:
          break
      }
      L.polyline(lineData, { color: color, weight: 1, dashArray: '5' }).addTo(map)
    },
    // 绘制台风路径地图
    leaflet1() {
      // var normalm = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', {
      //   maxZoom: 18,
      //   minZoom: 4
      // })
      // var normala = L.tileLayer.chinaProvider('TianDiTu.Normal.Annotion', {
      //   maxZoom: 18,
      //   minZoom: 4
      // })
      // var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
      //   maxZoom: 18,
      //   minZoom: 4
      // })
      // var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
      //   maxZoom: 18,
      //   minZoom: 4
      // })
      // var normal = L.layerGroup([normalm, normala])
      // var image = L.layerGroup([imgm, imga])
      // var baseLayers = {
      //   '影像': image,
      //   '地图': normal
      // }
      // var overlayLayers = {}
      // var map = L.map('typhoonMap', {
      //   center: [26.303, 133.67],
      //   zoom: 5,
      //   layers: [image],
      //   zoomControl: false
      // })
      let map = ''
      map = L.CreateTianDiTuMap('typhoonMap', {
        crs: L.CRS.EPSG4490,
        zoomControl: false
      }).setView([26.503, 133.67], 5)
      // L.tileLayer.CustomArcGISServerLayer(
      //   config.ApiYJ + '/files/layers/', // 地图服务地址
      //   {
      //     minZoom: 8, // 最小缩放等级
      //     maxZoom: 21 // 最大缩放等级
      //   }
      // )
      this.typhoonMap = map
      // L.control.layers(baseLayers, overlayLayers).addTo(map)
      L.control
        .zoom({
          zoomInTitle: '放大',
          zoomOutTitle: '缩小'
        })
        .addTo(map)
      var linestr24 = [
        [0, 105],
        [4.5, 113],
        [11, 119],
        [18, 119],
        [22, 127],
        [30, 127],
        [34, 127]
      ]
      var linestr48 = [
        [0, 105],
        [0, 120],
        [15, 132],
        [30, 132],
        [34, 132]
      ]
      var myIcon24 = L.icon({
        iconUrl: require('@/assets/map/images/hour24.png'),
        iconSize: [15, 80]
      })
      var myIcon48 = L.icon({
        iconUrl: require('@/assets/map/images/hour48.png'),
        iconSize: [15, 80]
      })
      // 24小时警戒线
      L.polyline(linestr24, { color: '#BFBF04', weight: 2 }).addTo(map)
      // 48小时警戒线
      L.polyline(linestr48, { color: '#627BFF', weight: 2 }).addTo(map)
      var marker24 = L.marker([26, 127], { icon: myIcon24 })
      var marker48 = L.marker([26, 132], { icon: myIcon48 })
      marker24.addTo(map)
      marker48.addTo(map)
      map.on('zoomend', function() {
        let zoomVal = map.getZoom()
        if (zoomVal < 5) {
          marker24.remove()
          marker48.remove()
        } else {
          marker24.remove()
          marker48.remove()
          marker24.addTo(map)
          marker48.addTo(map)
        }
      })
    },
    // 绘制台风路径
    drawTyphoonRouter(typhoonData, typhoonTestData) {
      let map = this.typhoonMap
      //  数据转换
      if (typhoonData) {
        var allpoints = this.dataHandler(typhoonTestData, map)
        // var allNewPoints = this.pointHandler(typhoonTestData)
        // 根据坐标点数组polylinePoints通过 L.polyline 方法 绘制折线，颜色为蓝色#0a7ccd
        var polyline = L.polyline(allpoints, { color: '#0a7ccd' }).addTo(map)
        // polyline.snakeIn()
        map.removeLayer(polyline)
        // line
        var lineLayer
        // Marker
        var marker
        // icon
        var typhoonIcon = L.icon({
          iconUrl: typhoonImg,
          iconSize: [40, 40]
        })
        // this.animateDrawLine(lineLayer, marker, allpoints, typhoonIcon, map, typhoonData, typhoonTestData)
        /* 动态绘制折线 */
        this.animateDrawLine(lineLayer, marker, allpoints, typhoonIcon, map, typhoonData, typhoonTestData)
      }
      this.loading3 = false
    },
    // 绘制路径
    animateDrawLine(lineLayer, marker, allpoints, typhoonIcon, map, typhoonData, typhoonTestData) {
      // allpoints 是上边介绍的数据转换的结果
      var allpoinstLength = allpoints.length
      // 定义用来存放递增元素的经纬度数据
      var drawPoints = []
      var count = 0
      // 定时器100ms，动态的塞入坐标数据
      this.timer = setInterval(() => {
        if (count < allpoinstLength) {
          drawPoints.push(allpoints[count])
          count++
          // 清除之前绘制的折线图层
          if (lineLayer && count !== allpoinstLength) {
            map.removeLayer(lineLayer)
            lineLayer = null
          }
          // 清除marker图层
          if (marker && count !== allpoinstLength) {
            map.removeLayer(marker)
            marker = null
          }
          // 最新数据点drawPoints绘制折线
          lineLayer = L.polyline(drawPoints, { color: '#0a7ccd', weight: 1 }).addTo(map)

          // 根据最新数组最后一个点绘制marker
          if (count === allpoinstLength) {
            map.removeLayer(marker)
            // 如果是台风最后一个点，则自动popup弹窗
            marker = L.marker(drawPoints[allpoinstLength - 1], { icon: typhoonIcon })
              .addTo(map)
              .bindPopup('<b>' + typhoonData['name'] + '(' + typhoonData['timeformate'] + ')')
              .openPopup()
          } else {
            marker = L.marker(drawPoints[count - 1], { icon: typhoonIcon }).addTo(map)
          }
        }
      }, 100)
    },
    /* 数据转换 & 绘制折线图 */
    dataHandler(typhoonTestData, map) {
      // 获取台风坐标点数据对象
      var forecast = typhoonTestData['points']
      // 定义折线点数据
      var polylinePoints = []
      // 循环拼接数据[[经度，纬度],[经度,纬度]] 的格式
      var myIcon1 = L.icon({
        iconUrl: require('@/assets/map/images/marker1.png'),
        iconSize: [15, 15]
      })
      var myIcon2 = L.icon({
        iconUrl: require('@/assets/map/images/marker2.png'),
        iconSize: [15, 15]
      })
      var myIcon3 = L.icon({
        iconUrl: require('@/assets/map/images/marker3.png'),
        iconSize: [15, 15]
      })
      var myIcon4 = L.icon({
        iconUrl: require('@/assets/map/images/marker4.png'),
        iconSize: [15, 15]
      })
      var myIcon5 = L.icon({
        iconUrl: require('@/assets/map/images/marker5.png'),
        iconSize: [15, 15]
      })
      var myIcon6 = L.icon({
        iconUrl: require('@/assets/map/images/marker6.png'),
        iconSize: [15, 15]
      })
      var myIcon = myIcon1
      for (var i = 0; i < forecast.length; i++) {
        var p = forecast[i]
        polylinePoints.push([Number(p['lat']), Number(p['lng'])])
      }
      forecast.forEach((item) => {
        var sevenRadius = item.radius7.split('|')
        var tenRadius = item.radius10.split('|')
        var twelveRadius = item.radius12.split('|')
        sevenRadius.forEach((item, index) => {
          sevenRadius[index] = Number(item)
        })
        tenRadius.forEach((item, index) => {
          tenRadius[index] = Number(item)
        })
        twelveRadius.forEach((item, index) => {
          twelveRadius[index] = Number(item)
        })
        sevenRadius = sevenRadius.sort()
        tenRadius = tenRadius.sort()
        twelveRadius = twelveRadius.sort()
        if (sevenRadius[0] === sevenRadius[sevenRadius.length - 1]) {
          sevenRadius = sevenRadius.splice(0, 1)
        } else if (sevenRadius[0] > sevenRadius[sevenRadius.length - 1]) {
          let temp1 = sevenRadius[0]
          let temp2 = sevenRadius[sevenRadius.length - 1]
          sevenRadius[0] = temp2
          sevenRadius[sevenRadius.length - 1] = temp1
        }
        if (tenRadius[0] === tenRadius[tenRadius.length - 1]) {
          tenRadius = tenRadius.splice(0, 1)
        } else if (tenRadius[0] > tenRadius[tenRadius.length - 1]) {
          let temp1 = tenRadius[0]
          let temp2 = tenRadius[tenRadius.length - 1]
          tenRadius[0] = temp2
          tenRadius[tenRadius.length - 1] = temp1
        }
        if (twelveRadius[0] === twelveRadius[twelveRadius.length - 1]) {
          twelveRadius = twelveRadius.splice(0, 1)
        } else if (twelveRadius[0] > twelveRadius[twelveRadius.length - 1]) {
          let temp1 = twelveRadius[0]
          let temp2 = twelveRadius[twelveRadius.length - 1]
          twelveRadius[0] = temp2
          twelveRadius[twelveRadius.length - 1] = temp1
        }
        let points = [Number(item['lat']), Number(item['lng'])]
        let powerValue = item.power
        if (powerValue > 5 && powerValue <= 7) {
          // 热带低压6-7
          myIcon = myIcon1
        } else if (powerValue > 7 && powerValue <= 9) {
          // 热带风暴8-9
          myIcon = myIcon2
        } else if (powerValue > 9 && powerValue <= 11) {
          // 强热带风暴10-11
          myIcon = myIcon3
        } else if (powerValue > 11 && powerValue <= 13) {
          // 台风12-13
          myIcon = myIcon4
        } else if (powerValue > 13 && powerValue <= 15) {
          // 强台风14-15
          myIcon = myIcon5
        } else if (powerValue >= 16) {
          // 超强台风>=16
          myIcon = myIcon6
        }
        L.marker(points, { icon: myIcon })
          .addTo(map)
          .bindTooltip(
            '<div class="typhoonName"><h3>' +
              typhoonTestData.name +
              '</h3>' +
              '<span class="time">' +
              item.time +
              '</span>' +
              '</div>' +
              '<div id="tab">' +
              '<ul class="tab">' +
              '<li class="tab_nav on">' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>中心位置:</span></div>' +
              '<div class="contentnum"><span>' +
              item.lng +
              '°' +
              '/' +
              item.lat +
              '°' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>风速风力:</span></div>' +
              '<div class="contentnum"><span>' +
              item.speed +
              ' 米/秒,' +
              '</span>' +
              '<span style="color:red">' +
              item.power +
              '级' +
              '(' +
              item.strong +
              ')' +
              '</span>' +
              '</div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>中心气压:</span></div>' +
              '<div class="contentnum"><span>' +
              item.pressure +
              ' 百帕' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet">' +
              '<div class="contentname"><span>移速移向:</span></div>' +
              '<div class="contentnum"><span>' +
              item.movespeed +
              ' 公里/小时,' +
              item.movedirection +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (sevenRadius[0] === 0 || sevenRadius.length < 2 ? ' hidden_img' : '') +
              '">' +
              '<div class="contentname"><span>七级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              sevenRadius[0] +
              '~' +
              sevenRadius[sevenRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (sevenRadius[0] !== 0 && sevenRadius.length < 2 ? '' : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>七级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              sevenRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (tenRadius[0] === 0 || tenRadius.length < 2 ? ' hidden_img' : '') +
              '">' +
              '<div class="contentname"><span>十级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              tenRadius[0] +
              '~' +
              tenRadius[tenRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (tenRadius[0] !== 0 && tenRadius.length < 2 ? '' : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>十级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              tenRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (twelveRadius[0] === 0 || twelveRadius.length < 2 ? ' hidden_img' : '') +
              '">' +
              '<div class="contentname"><span>十二级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              twelveRadius[0] +
              '~' +
              twelveRadius[twelveRadius.length - 1] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '<div class="tabcontnet' +
              (twelveRadius[0] !== 0 && twelveRadius.length < 2 ? '' : ' hidden_img') +
              '">' +
              '<div class="contentname"><span>十二级半径:</span></div>' +
              '<div class="contentnum"><span>' +
              twelveRadius[0] +
              ' 公里' +
              '</span></div>' +
              '</div>' +
              '</li>' +
              '</ul>' +
              '</div>',
            {
              parmanent: true,
              direction: 'top',
              sticky: true,
              className: 'animate-tooltip'
            }
          )
      })
      return polylinePoints
    },
    /* 数据转换 & 绘制点 */
    pointHandler(typhoonTestData) {
      // 获取台风坐标点数据对象
      var forecast = typhoonTestData['points']
      // 定义折线点数据
      var polylinePoints = []
      var polylinePointsObj = []
      var polylinePointsPower = []
      // 循环拼接数据[[经度，纬度],[经度,纬度]] 的格式
      for (var i = 0; i < forecast.length; i++) {
        var p = forecast[i]
        polylinePoints.push([Number(p['lat']), Number(p['lng'])])
        polylinePointsObj.latlng = [Number(p['lat']), Number(p['lng'])]
        polylinePointsObj.power = p.power
        polylinePointsPower.push(polylinePointsObj)
      }
      return polylinePointsPower
    },
    tfqDialogCancel() {
      this.tfqdialogFormVisible = false
      this.checkItem(this.selectedTime[3], 3)
    },
    // 列表滚动方法
    scrolltable(val) {
      let that = this
      let refs = that.$refs
      const table = refs[val]
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper || ''
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每200毫秒移动1像素)
      // 元素自增距离顶部1像素
      if (this.enterList) {
        divData.scrollTop += 1.5
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0
        }
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.checkItem(this.selectedTime[3], 3)
    })
  },
  async mounted() {
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
      if (this.watchfull) {
        this.backitem = false
      } else {
        this.backitem = true
      }
    }

    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.timer1 = setInterval(() => {
      if (this.typhoonMap) {
        this.typhoonMap.remove()
      }
      _this.leaflet1()
      _this.gettyphooninfo()
    }, 60 * 1000 * 5)

    // this.reservoirwater()
    this.gettyphooninfo()
    this.rainoverflow()
    this.resoverflow(1)
    this.resoverflow(2)
    this.warnvillage()
    this.$nextTick(() => {
      _this.leaflet()
      _this.leaflet1()
    })
    this.getnowtime()
    await this.riverwater()
    await this.reservoirwater()
    this.loading = false
    this.Global.elementFix(this, this.$refs['singleStationContent'], document.getElementById('refline3'), false, (height) => {
      _this.tableheight = height
    })
    // this.Global.elementFix(this, this.$refs['realtimewaterContent'], document.getElementById('refline3'), false, (height) => {
    //   _this.rtableheight = height
    // })
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('right')
      let overDiv = document.getElementsByClassName('overtable')
      let overresDiv = document.getElementsByClassName('overrestable')
      if (window.screen.width <= 1366) {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 120 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 155 + 'px'
      } else {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 160 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 215 + 'px'
      }
    })
    // 列表自动滚动
    this.timer = setInterval(() => {
      // 拿到表格挂载后的真实DOM
      this.scrolltable('commontable')
      this.scrolltable('commonrestable')
      this.scrolltable('singlesta')
    }, 100)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style>
.select-option {
  z-index: 99999 !important;
  border: 1px solid #00f0ff;
  background-color: #060a22;
  top: 120px !important;
}
.select-option .el-select-dropdown__item {
  background-color: #060a22;
  color: #ffffff;
}
.select-option .el-select-dropdown__item.hover,
.select-option .el-select-dropdown__item:hover {
  background-color: #10173e;
}
</style>
<style lang="less" scoped>
@import url('../../assets/map/leaflet.css');
.centerMapContent {
  width: 100%;
  height: 1080px;
  position: relative;
}
#centermap {
  width: 100%;
  height: 1080px;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 999;
}
@media screen and (min-height: 1100px) {
  .centerMapContent {
    width: 100%;
    height: 100%;
    position: relative;
  }
  #centermap {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  /* background:rgba(162,44,25,.6); */
  background-image: url(~@/assets/meiyu/chaojin.png);
  background-repeat: no-repeat;
  background-size: 141px 87px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  cursor: pointer;
  height: 87px;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 920px !important;
  height: 85px;
  left: 50%;
  margin-left: -460px;
  top: 85px;
  z-index: 9999;
}
.warn-name {
  width: 100%;
  height: 20px;
  font-size: 16px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 30px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.warn-num > span {
  font-size: 16px;
  color: #fff;
  margin-left: 10px;
}
</style>
<style lang="less" scoped>
.typhoon {
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  position: relative;
  .mapContent {
    width: 100%;
    height: 100%;
  }
  #typhoonMap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 998;
    /deep/ .leaflet-control-container {
      .leaflet-top.leaflet-left {
        top: 270px;
        left: 495px;
      }
      .leaflet-top.leaflet-right {
        top: 215px;
        right: 500px;
      }
    }
  }
  .typhoonMap_active {
    #centermap {
      z-index: 998;
    }
    #typhoonMap {
      z-index: 999;
    }
  }
  .tflj {
    height: 33px;
    border: 1px solid #2ccae6;
    border-radius: 30px;
    position: absolute;
    top: 230px;
    left: 400px;
    z-index: 999;
    cursor: pointer;
    :hover {
      background-color: #00dcfc;
      border-radius: 30px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tflj_active {
    background-color: #00dcfc;
    border-radius: 30px;
  }
  .tflj_disable {
    display: none;
  }
  .el-dialog {
    .topthree {
      // display: inline-block;
      height: 70px;
      // justify-content: space-between;
      // display: flex;
      .topitem {
        // margin-top: 25px;
        position: relative;
        display: inline-block;
        color: #fff;
        width: 117px;
        margin-left: 45px;
        margin-top: 25px;
        img {
          width: 117px;
          height: 71px;
        }
        .topdesc {
          font-size: 14px;
          position: absolute;
          top: 11px;
          left: 25px;
          width: 100px;
          left: 50%;
          margin-left: -50px;
          height: 15px;
          text-align: center;
        }
        .val {
          .topdesc;
          top: 35px;
          left: 45px;
          font-size: 24px;
          text-align: center;
          font-style: italic;
          font-weight: 500;
          .danwei {
            font-size: 14px;
            position: absolute;
            top: 10px;
          }
        }
      }
    }
    .title {
      height: 33px;
      position: relative;
      margin-top: -8px;
      .titlename {
        height: 33px;
        position: relative;
        /deep/ .titlename_select {
          position: absolute;
          top: -13px;
          .el-input--suffix {
            .el-input__inner {
              width: 160px;
              background: #060a22;
              border: none;
              color: #ffffff;
              font-size: 18px;
            }
          }
        }
        .button {
          position: relative;
          display: inline-block;
          padding: 0.5rem 1rem;
          background: transparent;
          color: white;
          text-transform: uppercase;
          text-decoration: none;
          font: bold 200%/1 sans-serif;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 0;
            background: #fff;
            transform: skew(45deg);
          }
        }
        .titlename_span {
          font-size: 18px;
          color: #fff;
          position: absolute;
          top: 0;
        }
        .titlename_up {
          width: 100%;
          height: 100%;
          span.ssyq,
          span.sssq {
            width: 20%;
            font-size: 18px;
            display: block;
            float: left;
            color: #fff;
          }
          .selected_time {
            width: 80%;
            height: 100%;
            float: right;
            .time_item {
              cursor: pointer;
              height: 30px;
              float: right;
              padding: 0 7px;
              line-height: 26px;
              display: block;
              font-size: 14px;
              color: #ffffff;
              border: 1px solid #079eb6;
              transform: skewX(-30deg);
              span {
                display: block;
                transform: skewX(30deg);
              }
            }
            .item_active {
              background: #064961;
            }
          }
        }
        img {
          width: 100%;
          height: 7px;
          position: absolute;
          top: 27px;
        }
      }
    }
  }
  .top {
    background-image: url('~@/assets/meiyu/top.png');
    background-repeat: no-repeat;
    background-size: 100% 200%;
    height: 77px;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 99999;
    .topdate {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      left: 65px;
    }
    .title {
      margin-top: 23px;
      font-size: 32px;
      color: #00f0ff;
      font-weight: bold;
      display: inline-block;
    }
    .person {
      color: #fefefe;
      font-size: 15px;
      position: absolute;
      top: 15px;
      right: 90px;
      .dbld {
        span {
          color: #fec307;
        }
      }
      .zbry {
        .dbld;
        margin-left: 30px;
      }
    }
    .back {
      position: absolute;
      cursor: pointer;
      right: 15px;
      top: 8px;
      width: 70px;
      img {
        width: 26px;
        height: 24px;
      }
      .backdesc {
        color: #00dcfc;
        font-size: 15px;
        line-height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -8px;
        margin-left: 5px;
      }
    }
    .full {
      .back;
      right: 75px;
    }
  }
  .left {
    width: 370px;
    height: 100%;
    position: absolute;
    top: 75px;
    bottom: 40px;
    left: 15px;
    z-index: 99999;
    .warning {
      width: 430px;
      height: 85px;
      line-height: 85px;
      text-align: center;
      background-image: url('~@/assets/meiyu/warningbox.png');
      background-repeat: no-repeat;
      background-size: 110% 200%;
      background-position: -14px -43px;
      img {
        margin-left: 30px;
        width: 147px;
        height: 23px;
      }
      span {
        margin-left: 20px;
        font-size: 18px;
        color: #fff;
        float: right;
        margin-right: 55px;
      }
    }
    .typhooninfo {
      font-size: 15px;
      width: 100%;
      height: 124px;
      margin-top: 10px;
      background: #060a22;
      box-shadow: 0 0 8px #253578;
      padding: 15px 15px;
      color: #fff;
      /deep/ .el-select {
        height: 20px;
      }
      /deep/ .el-input {
        width: 100px;
      }
      /deep/ .el-input__inner {
        background-color: #060a22;
        color: #fff;
        border: none;
      }
      .contain {
        width: 340px;
        height: 124px;
        .wordcolor {
          color: #00deff;
        }
        .distance {
          margin-left: 30px;
        }
        .descrow {
          margin-top: 18px;
          .qiya,
          .fs {
            padding-left: 5px;
          }
        }
        img {
          width: 180px;
          height: 88px;
          display: block;
          margin: 0 auto;
        }
      }
    }
    .realtimerain {
      width: 100%;
      height: 200px;
      margin-top: 10px;
      background: #060a22;
      box-shadow: 0 0 8px #253578;
      padding: 15px 10px;
      .contain {
        width: 350px;
        height: 170px;
        .title {
          height: 33px;
          .titlename {
            height: 33px;
            position: relative;
            /deep/ .titlename_select {
              position: absolute;
              top: -13px;
              .el-input--suffix {
                .el-input__inner {
                  width: 160px;
                  background: #060a22;
                  border: none;
                  color: #ffffff;
                  font-size: 18px;
                }
              }
            }
            .button {
              position: relative;
              display: inline-block;
              padding: 0.5rem 1rem;
              background: transparent;
              color: white;
              text-transform: uppercase;
              text-decoration: none;
              font: bold 200%/1 sans-serif;
              &::before {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 0;
                background: #fff;
                transform: skew(45deg);
              }
            }
            .titlename_span {
              font-size: 18px;
              color: #fff;
              position: absolute;
              top: 0;
            }
            .titlename_up {
              width: 100%;
              height: 100%;
              span.ssyq,
              span.sssq {
                width: 20%;
                font-size: 16px;
                display: block;
                float: left;
                color: #fff;
              }
              .selected_time {
                width: 80%;
                height: 100%;
                float: right;
                .time_item {
                  cursor: pointer;
                  height: 30px;
                  float: right;
                  padding: 0 7px;
                  line-height: 26px;
                  display: block;
                  font-size: 14px;
                  color: #ffffff;
                  border: 1px solid #079eb6;
                  transform: skewX(-30deg);
                  span {
                    display: block;
                    transform: skewX(30deg);
                  }
                }
                .item_active {
                  background: #064961;
                }
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .barcharts {
          height: 170px;
          position: relative;
          .qqmyl {
            width: 75px;
            height: 37px;
            cursor: pointer;
            z-index: 99999;
            position: absolute;
            right: 0px;
            top: 0px;
            .allrain {
              color: #fff;
              font-size: 14px;
              position: absolute;
              top: 9px;
              right: 0;
              width: 70px;
            }
            .val {
              color: #fec307;
              font-size: 24px;
              position: absolute;
              top: 22px;
              right: 0;
              font-style: italic;
              .danwei {
                color: #fff;
                font-size: 14px;
              }
            }
          }
          #rainchart {
            width: 380px;
            height: 150px;
          }
        }
      }
    }
    .realtimewater {
      width: 100%;
      height: calc(100% - 446px);
      margin-top: 10px;
      padding: 15px 0;
      background: #060a22;
      box-shadow: 0 0 8px #253578;
      .contain {
        height: 100%;
        width: 370px;
        .title {
          margin-left: 27px;
          .titlename {
            height: 33px;
            position: relative;
            .titlename_up {
              width: 100%;
              height: 100%;
              .sssq {
                width: 20%;
                font-size: 18px;
                display: block;
                float: left;
                color: #fff;
              }
            }
            img {
              width: 380px;
              height: 7px;
              position: absolute;
              top: 27px;
            }
          }
        }
        .content {
          margin-top: 10px;
          width: 370px;
        }
      }
    }
  }
  .right {
    width: 400px;
    height: 100%;
    position: absolute;
    top: 75px;
    bottom: 40px;
    right: 15px;
    z-index: 9999;
    .realtimewater,
    .rightrealtimewater {
      .left .realtimerain;
      margin-top: 10px;
      height: calc(100% - 100px);
      padding: 15px 0;
      .contain {
        height: 290px;
        width: 385px;
        .title {
          margin-left: 13px;
        }
        .content {
          margin-top: 10px;
          width: 400px;
        }
      }
    }
  }
}
.typhoon /deep/ .el-dialog {
  background-color: #060a22;
  margin-top: 22vh !important;
  width: 47%;
  .el-dialog__body {
    padding-top: 10px;
    overflow: auto;
    height: 400px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.typhoon /deep/ .content .el-table tr.el-table__row--striped td {
  background: #061737;
}
.typhoon /deep/ #mapTypeSelect {
  width: 600px !important;
}
.typhoon /deep/ iframe {
  #map {
    .leaflet-control-container {
      display: none;
    }
  }
}
// 地图内标记点的点击事件弹窗样式
.typhoon #typhoonMap /deep/ .animate-tooltip {
  width: 350px;
  padding: 1px;
  .hidden_img {
    display: none !important;
  }
  .typhoonName {
    background: #0099cc;
    color: #ffffff;
    h3 {
      width: 30%;
      margin: 5px auto;
      display: inline-block;
      text-align: center;
    }
    .time {
      width: 65%;
      display: inline-block;
    }
  }
  #tab {
    position: relative;
    width: 90%;
    margin: 0 auto;
    .tab {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0 auto;
      .tabcontnet {
        width: 1005;
        height: 35px;
        font-size: 15px;
        line-height: 35px;
        border-bottom: 1px solid #ccc;
        .contentname {
          width: 40%;
          display: inline-block;
          color: #ccc;
        }
        .contentnum {
          width: 60%;
          display: inline-block;
        }
      }
    }
    li {
      list-style: none;
    }
    .tab_nav {
      width: 100%;
      max-height: 320px;
      overflow: auto;
    }
  }
}
.el-dialog {
  background-color: #060a22;
  .gateitem {
    margin-top: 17px;
    width: 100%;
    border: 1px solid #1a3a6c;
    .gatetop {
      height: 35px;
      line-height: 35px;
      background: #0f3164;
      .name {
        font-size: 15px;
        color: #fff;
        float: left;
        margin-left: 17px;
      }
      .time {
        color: #fff;
        font-size: 14px;
        float: right;
        margin-right: 10px;
      }
      .desc {
        font-size: 14px;
        color: #00deff;
        float: right;
        margin-right: 17px;
      }
    }
    .gateicons {
      margin-top: 6px;
      .gateicon {
        margin-left: 17px;
        height: 55px;
        position: relative;
        margin-top: 5px;
        text-align: center;
        width: 22px;
        height: 38px;
        img {
          width: 22px;
          height: 38px;
        }
        span {
          color: #fff;
          font-size: 14px;
          display: block;
        }
      }
    }
  }
}
.typhoon /deep/ .leaflet-bottom.leaflet-right {
  display: none;
}
.typhoon /deep/ .el-table tr {
  color: #fff;
  background: #060a22;
}
.typhoon /deep/ #choset .el-dialog {
  width: 500px;
  height: 200px;
}
.typhoon /deep/ .el-table td {
  padding: 5px 0;
  border: none;
}
.typhoon /deep/ .el-table th.is-leaf {
  border: none;
}
.typhoon /deep/ .el-table th {
  color: #00deff;
  background: #060a22;
}
.typhoon /deep/ .el-table .warning-row td {
  background: #b7b71f !important;
}
.typhoon /deep/ .el-table .success-row td {
  background: #dc3217 !important;
}
.typhoon /deep/ .el-table__body tr:hover > td {
  background: #072447;
}
.typhoon /deep/ .el-table::before {
  background: #060a22;
}
.typhoon /deep/ *::-webkit-scrollbar {
  width: 0.25rem;
  height: 0.25rem;
  background-color: #072351;
}
.typhoon /deep/ *::-webkit-scrollbar-track {
  border-radius: 0.1rem;
  background-color: #06214e;
}
.typhoon /deep/ *::-webkit-scrollbar-thumb {
  height: 0.2rem;
  border-radius: 0.1rem;
  background-color: #0c3974;
}
.typhoon /deep/ .el-table__header {
  table-layout: auto;
  border-collapse: separate;
}
.typhoon /deep/ .el-table__body-wrapper,
.typhoon /deep/ .is-scrolling-none,
.typhoon /deep/ .is-scrolling-right {
  height: 100% !important;
}
.el-table {
  background: #060a22;
}
#chartall,
#danzhan,
#zhazhan {
  z-index: 9999999 !important;
}
#rainchartAll {
  width: 1000px;
  height: 280px;
  margin: 50px auto 0 auto;
}
.tfqdialog {
  /deep/ .el-dialog {
    width: 20%;
    margin-top: 10vh !important;
    /deep/ .el-dialog__body {
      height: 80px !important;
      .block {
        margin-left: 20px;
      }
    }
  }
}
body /deep/ .el-picker-panel {
  z-index: 999999 !important;
}
.searchsta {
  width: 180px;
  height: 100%;
  text-align: center;
  /* display: inline-block; */
  float: right;
  line-height: 0px;
  margin-top: -7px;
}
.searchsta /deep/ .el-input__inner {
  background-color: transparent;
  border: 0.03125rem solid #079eb6;
  color: #ddd;
}
.searchsta /deep/ .el-input__inner:hover {
  border-color: #079eb6;
}
.stawater {
  overflow: hidden;
  margin-right: 100px;
}
.right /deep/ .el-table__empty-block {
  height: 0;
  min-height: 0;
}
.warnItems {
  & > div:nth-of-type(n + 2) {
    margin-top: 8px;
  }
  & > div {
    /deep/ span:nth-child(1) {
      margin-right: 8px;
    }
    /deep/ .red {
      color: red;
      font-weight: bold;
    }
  }
}
 .item{
  position: relative;
  .showTool {
    position: absolute;
    background:#C5B598 !important;
    color:#666;
    text-align: center;
  }
}
</style>
